import React, { Component } from 'react'

class ErrorBoundary extends Component {
	constructor(props) {
		super(props)
		this.state = { hasError: false }
	}

	// обновляет стейт для отображение статик юзер интерфейса
	static getDerivedStateFromError(error) {
		// Update state so the next render shows the fallback UI
		return { hasError: true, error_str: error }
	}

	// Регистрирует и дропает в консоль ошибку
	componentDidCatch(error, errorInfo) {
		// Log the error to an error reporting service console
		console.error('Error caught by Error Boundary:', error, errorInfo)
	}

	render() {
		if (this.state.hasError) {
			return (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						flexDirection: 'column',
						marginTop: '200px',
						gap: '20px',
					}}
				>
					<p
						style={{
							fontSize: '34px',
							textAlign: 'center',
						}}
					>
						Упс.. Произошла ошибка
					</p>
					<button
						style={{
							backgroundColor: 'rgb(127, 125, 243)',
							borderRadius: '13px',
							fontWeight: '500',
							padding: '6px 16px',
							border: 'none',
							color: 'white',
							height: '48px',
							width: '300px',
							cursor: 'pointer',
							fontSize: '16px',
							textAlign: 'center'
						}}
						onClick={() => (window.location.pathname = '/')}
					>
						Вернуться на главную
					</button>
				</div>
			)
		}

		return this.props.children
	}
}

export default ErrorBoundary
